
export enum ModalSizes {
    SMALL_WIDTH = '400px',
    MEDIUM_WIDTH = '600px',
    LARGE_WIDTH = '800px',
    EXTRA_LARGE_WIDTH = '1000px'
}